export default __webpack_public_path__ + "static/media/Montserrat-ExtraBoldItalic.5f136abd.ttf";